<script setup lang="ts">
defineProps<{ note: string; colspan: number; isLast: boolean }>()
</script>

<!-- The note spans the whole table so it is never clamped by the narrow bank column.
     It is pinned to the visible part of the scroll container (sized via cqw) so it
     wraps there instead of running off into the horizontally scrolled area.
     The parent scroll container must set `[container-type:inline-size]`. -->
<template>
  <tr>
    <td
      :colspan="colspan"
      :class="[
        'border-b border-l border-r border-gray-200 px-2 py-1.5 text-xs text-gray-500',
        isLast ? 'rounded-b-lg' : ''
      ]"
    >
      <div class="sticky left-2 w-[calc(100cqw-1rem-2px)]">{{ note }}</div>
    </td>
  </tr>
</template>
